var _defs, _ellipse, _g, _g2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmalgam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 323.37 312.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #c1272d;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 157.09,
    cy: 157.26,
    rx: 86.25,
    ry: 71.7
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 157.34,
    cy: 157.49,
    rx: 86.5,
    ry: 71.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 107.45,
    y1: 37.65,
    x2: 309.24,
    y2: 196.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.96,
    y1: 24.95,
    x2: 281.74,
    y2: 183.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.65,
    y1: 65.91,
    x2: 322.44,
    y2: 224.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.66,
    y1: 59.11,
    x2: 302.45,
    y2: 217.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.17,
    y1: 75.53,
    x2: 311.96,
    y2: 234.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.02,
    y1: 52.08,
    x2: 270.81,
    y2: 210.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.53,
    y1: 39.37,
    x2: 243.32,
    y2: 198.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.23,
    y1: 80.34,
    x2: 284.02,
    y2: 239.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 62.24,
    y1: 73.54,
    x2: 264.03,
    y2: 232.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 71.75,
    y1: 89.96,
    x2: 273.54,
    y2: 248.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.48,
    y1: 81.37,
    x2: 251.27,
    y2: 240.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.99,
    y1: 68.66,
    x2: 223.78,
    y2: 227.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 62.69,
    y1: 109.63,
    x2: 264.47,
    y2: 268.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.69,
    y1: 102.83,
    x2: 244.48,
    y2: 261.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.2,
    y1: 119.24,
    x2: 253.99,
    y2: 278.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.42,
    y1: 109.46,
    x2: 230.21,
    y2: 268.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.93,
    y1: 96.76,
    x2: 202.72,
    y2: 255.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.62,
    y1: 137.72,
    x2: 243.41,
    y2: 296.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.63,
    y1: 130.92,
    x2: 223.42,
    y2: 289.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 31.14,
    y1: 147.34,
    x2: 232.93,
    y2: 306.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.48,
    y1: 35.37,
    x2: 317.26,
    y2: 194.18
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 157.09,
    cy: 157.26,
    rx: 86.25,
    ry: 71.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 95.07,
    y1: 107.18,
    x2: 124.3,
    y2: 130.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.41,
    y1: 184.57,
    x2: 220.65,
    y2: 207.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 220.84,
    y1: 107.97,
    x2: 190.39,
    y2: 129.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120,
    y1: 182.61,
    x2: 89.55,
    y2: 204.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 156.74,
    cy: 157.13,
    rx: 47.32,
    ry: 39.34
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.32,
    y1: 118.39,
    x2: 156.32,
    y2: 195.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmalgam);
export default __webpack_public_path__ + "static/media/Amalgam.efeda756c1171cc885b1581f01004962.svg";
export { ForwardRef as ReactComponent };